//
// scroll-to -- a simple scroller
//    options:
//       easing      function, default is quint ease out
//
//       duration    duration of scroll (seconds)
//       OR:
//       speed       (a speed of 1 corresponds to 1000 pixels in 1 second)
//                   default: duration: 1 second
//
//       offset      number of pixels to 'miss' the target by, default 0
//

import clamp from './helpers/math-clamp';

function quint_ease_out(t) {
  return (t-=1)*t*t*t*t + 1;
}

const defaults = {
  duration: 1000,
  easing: quint_ease_out,
};


function state() {
  if (!window._scrollToState) {
    window._scrollToState = {
      raf_id: null,
      t_start: null,
      from: null,
      to: null,
      opts: { },
      offset_providers: [ ],
    };
  }
  return window._scrollToState;
}


function get_page_scroll() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
}


// scroll_to_y
// --------------------------------

function scroll_to_y(_to, _opts, disable_offset_providers) {
  cancel();
  bind_cancelers();

  const s = state();

  s.opts = Object.assign({}, defaults, _opts || {});
  s.from = get_page_scroll();

  if (s.opts.hasOwnProperty('offset')) {
    _to += _opts.offset;
  }

  if (!disable_offset_providers) {
    _to -= state().offset_providers.reduce(function(accum, el) {
      return accum + el.offsetHeight;
    }, 0);
  }

  s.to = clamp(_to, [0, document.body.offsetHeight - window.innerHeight]);

  if (s.opts.speed) {
    s.opts.duration = get_duration(s.opts.speed, Math.abs(s.to - s.from));
  }

  enqueue_frame();
}


// scroll_to_element
// --------------------------------

function scroll_to_element(element, _opts) {
  const _to = element.getBoundingClientRect().top
    + get_page_scroll()
    - parseInt(getComputedStyle(element, null).marginTop);

  scroll_to_y(_to, _opts);
}


// scroll_to_top
// --------------------------------

function scroll_to_top(_opts) {
  _opts = _opts || {};
  _opts.to = 0;
  _opts.offset = 0;

  scroll_to_y(0, _opts, true);
}


// cancel
// --------------------------------

function cancel() {
  const s = state();

  cancelAnimationFrame(s.raf_id);
  s.raf_id = null;
  s.t_start = null;
  unbind_cancelers();
}


// offset-providers
// --------------------------------

function register_offset_provider(el) {
  state().offset_providers.push(el);
}
function deregister_offset_provider(el) {
  state().offset_providers = state().offset_providers.filter(p => p !== el);
}


// event binding & unbinding
// --------------------------------

const cancel_events = [ 'mousedown', 'wheel', 'DOMMouseScroll', 'mousewheel', 'keyup', 'touchstart' ];
function bind_cancelers() {
  cancel_events.forEach(t => window.addEventListener(t, cancel));
}
function unbind_cancelers() {
  cancel_events.forEach(t => window.removeEventListener(t, cancel));
}


// cb - perform scroll in RAF loop
// --------------------------------

function cb(t) {
  const s = state();

  if (s.t_start === null) {
    s.t_start = t;
  }
  t = (t - s.t_start) / s.opts.duration;
  t = (s.opts.easing)(t);

  const cur = Math.round(s.from + (s.to - s.from)*t);
  if ((s.to > s.from && s.to > cur) || (s.to < s.from && s.to < cur)) {
    window.scrollTo(0, cur);
    enqueue_frame();
  }
  else {
    cancel();
  }
}
function get_duration(speed, distance) {
  return distance / speed;
}
function enqueue_frame() {
  state().raf_id = requestAnimationFrame(cb);
}

export {
  scroll_to_y,
  scroll_to_element,
  scroll_to_top,
  cancel,

  get_page_scroll,
  register_offset_provider,
  deregister_offset_provider,
};

